import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NavigationService } from 'src/app/providers/navigation.service';
import * as QRCode from 'qrcode';
import html2canvas from 'html2canvas';
import { ApiService } from 'src/app/providers/api.service';
import { LoaderServiceService } from 'src/app/providers/loader-service.service';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { SM_CONSTANTS } from 'src/app/shared/constants/sm-constants';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'sm-homeqr-available',
  templateUrl: './homeqr-available.component.html',
  styleUrls: ['./homeqr-available.component.scss']
})
export class HomeqrAvailableComponent implements OnInit {
  public loader: boolean = false;
  entityHashId: string = '';
  qrcodes:any = []
  private _apiSubscription: Subscription;
  base_url: string= environment.base_lookzup_web_url
  @ViewChild('qrCodeCanvas') qrCodeCanvas!: ElementRef;
  @ViewChild('captureContainer', { static: true }) captureContainer!: ElementRef;
  @ViewChild('qrCodeCanvas2') qrCodeCanvas2!: ElementRef;
  @ViewChild('captureContainer2', { static: true }) captureContainer2!: ElementRef;
  homeQRAvailable:boolean = false
  homeQRdata:any
  shopQRAvailable:boolean = false
  shopQRData:any
  constructor(private _navService: NavigationService,private _apiService: ApiService, private loaderservice: LoaderServiceService, private route: ActivatedRoute) {
    this._apiSubscription = this._apiService.apiResult.subscribe(resData =>{
      if(resData.responseType === SM_CONSTANTS.RESULT_API_GET_BOOKING_QR){
        console.log(resData);
        this.qrcodes = resData.result ? resData.result : [];
        if(this.qrcodes.length > 0){
          this.qrcodes.forEach((element:any) => {
            element.link = this.base_url + '/qrcode/booking?qr_id=' + element.qr_code
            if(element.booking_type == '0'){
              this.homeQRdata = element
              QRCode.toCanvas(this.qrCodeCanvas2.nativeElement, element.link, (error) => {
                if (error) {
                  console.error('Error generating QR code:', error);
                }
              });
            }
          });
          
          // this.generateQRCode(this.qrcodes)
        }
      }
      this.loader = false;
      this.loaderservice.showLoader = false
    })
   }

  ngOnInit(): void {
  }

  downloadQR2(){
    
    html2canvas(this.captureContainer2.nativeElement).then(canvas => {
      // Convert canvas to an image URL
      const screenshotUrl = canvas.toDataURL('image/png');

      // Create a link and trigger download
      const link = document.createElement('a');
      link.href = screenshotUrl;
      // link.download = 'QR_' + this.parentData.data + '.png';
      link.download = 'QR_' + "test" + '.png';
      link.click();
    });
  }

}
